import { SET_USER_BRAND } from "./actions";

const INITIAL_STATE = null;

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	case SET_USER_BRAND:
		return {
			...state,
			...action.userBrand,
		};
	default:
		return state;
	}
};
